export const APP_DATA = {
  appName: 'Clasol Suite Apps',
  companyName: 'CLASOL',
  version: '1.0.0',
  apiUrl: process.env.REACT_APP_API_URL?.trim() || 'http://localhost:3000/api/v1',
}

export const API_REQUESTS_PAUSED = false
